import { Component, OnInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { EssencialService } from '../../services/essencial.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { buttons, mensajes } from '../../../../../assets/data/diccionario.js';
import { essencialModul } from '../../diccionarios/essencialModulo';


@Component({
  selector: 'app-csv-validar-essencial',
  templateUrl: './csv-validar-essencial.component.html',
  styleUrls: ['./csv-validar-essencial.component.css']
})
export class CsvValidarEssencialComponent implements OnInit {


  titulo = 'Selección: carga de clientes Jerarquia Essential';
  public mostrarFormulario = false;
  public loading: boolean = false;
  public listaVacia: boolean = true;

  public DAT_TITULOS = essencialModul.titulos;
  public DAT_AG_GRID = essencialModul.agGrid;
  public DAT_BTNCSS  = buttons;
  public TITULOS_STAND = mensajes;


  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];
  errorData: boolean = true;
  
  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private essecialServices: EssencialService,
  ){ }

  ngOnInit(): void {
    this.formulario = this.fb.group({ multipart: ['', [Validators.required]] });
    this.cargarGrid();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['CLIENTE', 'ORGANIZACION_VENTAS', 'CANAL_DISTRIBUCION', 'SECTOR', 'UNIDAD_NEGOCIO', 'CANAL_VENDEDOR', 'SUBCANAL', 'GRUPO_PRECIOS']];
    const data: any[] = [{
      'CLIENTE': '100001', 
      'ORGANIZACION_VENTAS': '1001',
      'CANAL_DISTRIBUCION': 10,
      'SECTOR': '00',
      'UNIDAD_NEGOCIO': 'CODIGO', 
      'CANAL_VENDEDOR': 'CODIGO', 
      'SUBCANAL':'CODIGO', 
      'GRUPO_PRECIOS': 'CODIGO'
    }];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  cargarGrid(){
    this.columnDefs = [
      { headerName: 'ESTADO', sortable: true, filter: true, width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      { width: 120, sortable: true, resizable: true, field: 'cliente' },
      { width: 120, sortable: true, resizable: true, field: 'nombreCliente' },
      { width: 120, sortable: true, resizable: true, field: 'orgaVentas' },
      { width: 120, sortable: true, resizable: true, field: 'canalDistribucion' },
      { width: 120, sortable: true, resizable: true, field: 'sector' },
      { width: 120, sortable: true, resizable: true, field: 'rucCliente' },
      { width: 120, sortable: true, resizable: true, field: 'padre', headerName :"U.Negocio" },
      { width: 120, sortable: true, resizable: true, field: 'hijo', headerName :"Canal" },
      { width: 120, sortable: true, resizable: true, field: 'subCanal' },
      { width: 120, sortable: true, resizable: true, field: 'grupoPrecios' },
      { headerName: 'ERROR', field: 'error.errorCampo', filter: true, width: 600, sortable: true,
        cellStyle: this.changeRowColor.bind(this),
      },
    ];
    this.rowSelection = 'multiple';
  }


  enviarFormulario() {
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    let params = '?usuario='+userData.login2;
    this.loading = true;
    this._util.confirmarSincronoPromesaNormal(
      {
        title : 'Esta seguro que desea enviar el siguiente archivo?',
        text  : this.titulo,
        action: 'Enviar',
        funcion: this.essecialServices.cargaCsvValidador(this.setFormData(this.formulario.value)),
        loading: true,
        context: this,
      }).then((res: any[]) => {
        // debugger
        this.mostrarFormulario = true;
        this.rowData = res;
        if (this.rowData.length > 0) {
          this.listaVacia = false;
          this.validarRowData();
        } else {
          this.listaVacia = true;
        }
      }).catch((err) => {
        console.log('Error ' + err);
        this.rowData = []; 
        this.listaVacia = true;
      });

      this.loading = false;
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title : 'Esta seguro que desea guardar?',
        text  : this.titulo,
        action: 'Guardar',
        funcion: this.essecialServices.saveCsvValidador(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  downloadDataCsv() {
    let data: any = [];    
    let cabecera: any[] = [['CLIENTE', 'NOMBRE_CLIENTE', 'ORGANIZACION_VENTAS', 'CANAL_DISTRIBUCION', 'SECTOR', 'RUC', 'UNIDAD_NEGOCIO', 'CANAL_VENDEDOR', 'SUBCANAL', 'GRUPO_PRECIOS', 'ERROR']];  
    
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
        data.push(
          {
            cliente : e.cliente,
            nombreC : e.nombreCliente,
            orga    : e.orgaVentas,
            canald  : e.canalDistribucion,
            sector  : e.sector,
            ruc     : e.rucCliente ? "'"+e.rucCliente : e.rucCliente,
            unidad  : e.padre,
            canal   : e.hijo,
            sCanal  : e.subCanal,
            gprecio : e.grupoPrecios,
            error2  : e.error ? e.error.errorCampo : "OK-VALIDADO"
          }
        );      
    });

    console.log("objeto a descargar", clonData );
    let name: string = "REGISTRO_ERRORES_JERARQUIA_ESSENTIAL.csv";

    this._util.exportCSV(cabecera, data, name);
    this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }


  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {'background-color': 'lightgreen', 'color': 'black', 'font-weight': 'bold'};
      }
      else {
        return {'background-color': '#FFC0CB', 'color': 'black', 'font-weight': 'bold'};
      }
    }
    return true;
  }

}
